import dateFnsFormat from 'date-fns/format';
import dateFnsIsValid from 'date-fns/isValid';
import locale from 'date-fns/locale/pt-BR';
import dateFnsParse from 'date-fns/parse';
import moment from 'moment';

import type { Moment } from 'moment';

export function dateParse(value: any, format: string = null): Date {
  if (!value) return value;
  if (value instanceof Date) return value;

  const date = !format ? new Date(value) : dateFnsParse(value, format, new Date(), { locale });
  if (!dateFnsIsValid(date)) return value;

  return date;
}

export function dateFormat(date: Date | string, format: string = 'dd/MM/yyyy'): string {
  if (!date) {
    return '-';
  }

  if (typeof date === 'string') {
    return dateFnsFormat(dateParse(date), format, { locale });
  }

  return dateFnsFormat(date, format, { locale });
}

export function dateMomentFormat(date: string | Moment, format: string = 'DD/MM/YYYY') {
  if (!date) {
    return '-';
  }

  return moment(date).format(format);
}

export function isDateExpired(date: string) {
  const dateToExpire = moment(date).startOf('day').toDate();

  const now = new Date();

  return moment(now).isAfter(dateToExpire);
}
